import { PencilSimpleLine, BookOpenText, Sparkle, BookBookmark, ShieldCheck, DeviceMobile, HandHeart, LockKey } from "@phosphor-icons/react";
import { Eyebrow } from "@/components/landing/shared";

const STEPS = [
  { icon: PencilSimpleLine, c: "#E06D53", t: "Write a memory", d: "Choose a Life Season, add a title, date, the people and places — and how it felt." },
  { icon: BookOpenText, c: "#36858B", t: "Keep it in your notebook", d: "Each season becomes a calm notebook page, arranged by date and easy to search." },
  { icon: Sparkle, c: "#D9A036", t: "Discover its meaning", d: "Optional Memory Insights offer a short, kind reflection based only on what you wrote." },
  { icon: BookBookmark, c: "#8C6CB0", t: "Create keepsakes", d: "When you're ready, turn a year — or your whole life — into a reflection or a Life Story Ebook." },
];

const PRIVACY = [
  { icon: LockKey, t: "Private by design", d: "Your diary is protected by your own username and password." },
  { icon: DeviceMobile, t: "Photos stay with you", d: "Ebook photos are prepared on your own device and never uploaded to our servers." },
  { icon: HandHeart, t: "Never sold or shared", d: "We never sell your stories or personal information." },
  { icon: ShieldCheck, t: "You stay in control", d: "Download your memories or delete your account at any time." },
];

export const HowItWorks = () => (
  <section data-testid="landing-how" className="bg-white py-20">
    <div className="mx-auto max-w-6xl px-5 sm:px-6">
      <Eyebrow color="#D9A036">How the journal works</Eyebrow>
      <h2 className="mt-3 font-serif text-3xl text-[#2D2824] sm:text-4xl">Gentle steps, at your own pace</h2>
      <ol className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <li key={s.t} className="relative rounded-2xl bg-[#FAF6F0] p-6">
            <span className="font-['Caveat',cursive] text-4xl" style={{ color: s.c }}>{i + 1}</span>
            <s.icon size={26} weight="duotone" className="mt-1" style={{ color: s.c }} />
            <h3 className="mt-3 font-serif text-xl text-[#2D2824]">{s.t}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-[#6E665E]">{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export const PrivacyPromise = () => (
  <section data-testid="landing-privacy" className="bg-[#EBF4F5] py-20">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 sm:px-6 lg:grid-cols-[1fr_1.4fr]">
      <div>
        <Eyebrow color="#2B6B70">Privacy reassurance</Eyebrow>
        <h2 className="mt-3 font-serif text-3xl text-[#2D2824] sm:text-4xl">Your memories are yours alone</h2>
        <p className="mt-3 text-[#6E665E]">Private. Personal. Always yours.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {PRIVACY.map((p) => (
          <div key={p.t} className="rounded-2xl bg-white p-5 shadow-sm">
            <p.icon size={24} weight="duotone" className="text-[#36858B]" />
            <h3 className="mt-3 font-medium text-[#2D2824]">{p.t}</h3>
            <p className="mt-1 text-sm leading-relaxed text-[#6E665E]">{p.d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
